var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StyledHeader = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    padding: 30px;\n    background-color: #f5f5f5;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"], ["\n    width: 100%;\n    padding: 30px;\n    background-color: #f5f5f5;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"])));
var templateObject_1;
